import { Timestamp } from "firebase/firestore";
export const candidateList = [
    {
        name: 'Jorge',
        lastName: 'Barrera',
        education: [
            {
                fieldStudy: 'Primary',
                institution: 'Padre Andre Coindre',
                graduationDate: Timestamp.fromDate(new Date('2011-01-01')),
                degree: 'Basic'
            },
            {
                fieldStudy: 'Ingenieer Informatic',
                graduationDate: Timestamp.fromDate(new Date('2021-01-01')),
                degree: 'University',
                institution: 'DUOC UC'
            },
            {
                institution: 'INCO',
                graduationDate: Timestamp.fromDate(new Date('2016-09-09')),
                fieldStudy: 'Secundary',
                degree: 'Middle'
            }
        ],
        experience: [
            {
                dateStart: Timestamp.fromDate(new Date('2011-01-01')),
                dateEnd: Timestamp.fromDate(new Date('2012-01-01')),
                actualPosition: true,
                description: 'As a [title] at [company], I successfully led a team of professionals and implemented strategies that resulted in a significant increase in revenue. I played a key role in enhancing operational efficiency and reducing costs through process improvements. Additionally, I developed and maintained strong relationships with key clients, resulting in an increase in customer satisfaction and repeat business. Overall, I achieved measurable outcomes and contributed to the overall success of the organization.',
                company: 'City',
                title: 'New position'
            },
            {
                dateStart: Timestamp.fromDate(new Date('2011-01-01')),
                dateEnd: Timestamp.fromDate(new Date('2012-01-01')),
                actualPosition: true,
                description:
                    'As a [title] at [company], I successfully led a team of professionals and implemented strategies that resulted in a significant increase in revenue. I played a key role in enhancing operational efficiency and reducing costs through process improvements. Additionally, I developed and maintained strong relationships with key clients, resulting in an increase in customer satisfaction and repeat business. Overall, I achieved measurable outcomes and contributed to the overall success of the organization.',
                company: 'City',
                title: 'New position'
            },
            {
                description:
                    'Décrivez vos responsabilités et vos réalisations en termes d’impact et de résultats. Citez des exemples tout en restant concis.',
                dateStart: Timestamp.fromDate(new Date('2013-01-01')),
                title: 'New position',
                dateEnd: Timestamp.fromDate(new Date('2014-01-01')),
                company: 'New position / City',
                actualPosition: false
            },
            {
                company: 'New position / City',
                dateStart: Timestamp.fromDate(new Date('2015-01-01')),
                dateEnd: Timestamp.fromDate(new Date('2016-01-01')),
                actualPosition: false,
                description: 'Décrivez vos responsabilités et vos réalisations en termes d’impact et de résultats. Citez des exemples tout en restant concis.',
                title: 'New position',
            },
            {
                actualPosition: false,
                title: 'Long',
                dateStart: Timestamp.fromDate(new Date('2011-01-01')),
                dateEnd: Timestamp.fromDate(new Date('2017-01-01')),
                company: 'Long / Mapping Cie',
                description: 'Décrivez vos responsabilités et vos réalisations en termes d’impact et de résultats. Citez des exemples tout en restant concis.',
            }
        ],
        skills: [
            { level: 5, name: 'Inventory' },
            { name: 'Conflict Resolution', level: 5 },
            { level: 5, name: 'Health & Safety' },
            { level: 5, name: 'Proactive' },
            { name: 'Languages', level: 5 }]
    }


]

export const candidateFrance = [
    {
        'name': 'Candidate 1',
        'education': [
            {
                'fieldStudy': 'Business Administration (MBA)',
                'institution': 'Université de Sherbrooke',
                'graduationDate': Timestamp.fromDate(new Date('2013-02-02')),
                'degree': 'MBA'
            },
            {
                'fieldStudy': 'Commerce (Major: Marketing)',
                'institution': 'Université Concordia',
                'graduationDate': Timestamp.fromDate(new Date('2003-02-02')),
                'degree': 'Baccalauréat '
            },
            {
                'fieldStudy': 'Administration',
                'institution': 'Cégep John Abbott',
                'graduationDate': Timestamp.fromDate(new Date('2000-02-02')),
                'degree': "Diplôme d'Études Collégiales"
            }
        ],
        'experience': [
            {
                'dateStart': Timestamp.fromDate(new Date('2018-02-02')),
                'dateEnd': Timestamp.fromDate(new Date('2023-02-02')),
                'actualPosition': false,
                'description': "Gestion de territoire : Responsabilité de la gestion, planification, et analyse de marché d'un territoire pour surpasser les objectifs de vente. \nPromotion de produit : Compétence en promotion auprès de distributeurs via des stratégies marketing ciblées pour booster visibilité et ventes.\nService client : Engagement dans un service client de qualité, offrant assistance proactive et réactive pour satisfaction et fidélisation.\nService après-vente : Gestion du service après-vente pour répondre rapidement aux demandes, assurant le maintien de relations de confiance.\nRéalisations : Distinction par le Club du Président en 2018 et 2020 pour performances exceptionnelles en ventes et leadership, preuve d'un engagement vers l'excellence.",
                'company': 'Techo-Bloc Inc.',
                'title': 'Représentant des ventes'
            },
            {
                'dateStart': Timestamp.fromDate(new Date('2015-02-02')),
                'dateEnd': Timestamp.fromDate(new Date('2017-02-02')),
                'actualPosition': false,
                'description': 'Vente, gestion et coordination de travaux de rénovation',
                'company': 'Gestion Pur H.D. Inc',
                'title': 'Travailleur autonome'
            },
            {
                'dateStart': Timestamp.fromDate(new Date('2004-02-02')),
                'dateEnd': Timestamp.fromDate(new Date('2005-02-02')),
                'actualPosition': false,
                'description': 'Logistique de transport\nNégociation avec client, transporteur et fournisseur\nVentes de services',
                'company': 'CH Robinson Worldwide',
                'title': 'Représentant des ventes'
            }
        ],
        'skills': [
            { 'name': 'Ventes', 'level': 5 },
            { 'name': 'Autonomie', 'level': 5 },
            { 'name': 'Service-Clientèle', 'level': 4 },
            { 'name': 'Négociation', 'level': 4 },
            { 'name': 'Excel', 'level': 4 }]
    },
    {
        'name': 'Candidate 2',
        'education': [
            {
                'fieldStudy': 'Assurance de dommages',
                'institution': 'Cégep de Jonquière, Québec',
                'graduationDate': Timestamp.fromDate(new Date('2019-02-02')),
                'degree': 'Attestation d’études collégiales'
            },
            {
                'fieldStudy': 'Assurance maladie et accident',
                'institution': 'Combined Assurances, Granby',
                'graduationDate': Timestamp.fromDate(new Date('2013-02-02')),
                'degree': 'Formation en assurance'
            },
            {
                'fieldStudy': 'Vente d’assurances',
                'institution': 'Combined Assurances, Granby',
                'graduationDate': Timestamp.fromDate(new Date('2013-02-02')),
                'degree': 'Formation de vente'
            }
        ],
        'experience': [
            {
                'dateStart': Timestamp.fromDate(new Date('2022-02-02')),
                'dateEnd': Timestamp.fromDate(new Date('2023-02-02')),
                'actualPosition': false,
                'description': "Planifier, répartir et superviser le travail des participants aux ressources humaines.\n Traiter les ventes, les feuilles de temps et corriger les tests d’admission.\n Intervenir auprès des participants concernant leur rendement et leurs enjeux.\n Participer aux réunions de coordination interdépartementale et monter les horaires.\n Maîtrise des tâches et du rôle dans un court délai afin d'assurer le bon fonctionnement de l'organisme à seulement deux employés.",
                'company': "Entreprise d’entraînement PlastiGroulx",
                'title': 'Technicienne aux opérations : ressources humaines et ventes'
            },
            {
                'dateStart': Timestamp.fromDate(new Date('2020-02-02')),
                'dateEnd': Timestamp.fromDate(new Date('2021-02-02')),
                'actualPosition': false,
                'description': "Rechercher les meilleurs fournisseurs et y référer le client.\n Négocier avec différents partenaires d'assurance et offrir la meilleure solution pour le client.\n Servir d'intermédiaire entre le client et l'expert en sinistre.",
                'company': 'Consilium Assurance',
                'title': 'Courtière en assurance de dommages'
            },
            {
                'dateStart': Timestamp.fromDate(new Date('2019-02-02')),
                'dateEnd': Timestamp.fromDate(new Date('2020-02-02')),
                'actualPosition': false,
                'description': 'Analyser les besoins des clients et vérifier les rapports des inspecteurs.\n Donner suite aux réclamations et répondre aux requêtes de la clientèle.\n Accompagner émotionnellement le client dans la démarche.',
                'company': 'SCM Indemnipro',
                'title': 'Experte en sinistre'
            }],
        'skills': [
            { 'name': 'Assurance', 'level': 4 },
            { 'name': 'Gestion', 'level': 4 },
            { 'name': 'Ventes', 'level': 3 },
            { 'name': 'Ressources Humaines', 'level': 3 },
            { 'name': 'Excel', 'level': 3 }
        ]
    },
    {
        'name': 'Candidate 3',
        'education': [{
            'fieldStudy': 'Business Administration',
            'institution': 'Hult International Business School ',
            'graduationDate': Timestamp.fromDate(new Date('2022-02-02')),
            'degree': 'Maîtrise en Administration des Affaires (EMBA)'
        },
        {
            'fieldStudy': 'Hospitality Management',
            'institution': 'Université Cornell ',
            'graduationDate': Timestamp.fromDate(new Date('2017-02-02')),
            'degree': 'Certificat en Gestion Hôtelière'
        },
        {
            'fieldStudy': '',
            'institution': '',
            'graduationDate': Timestamp.fromDate(new Date('1992-02-02')),
            'degree': 'Diplôme d’Études Collégiales'
        }],
        'experience': [
            {
                'dateStart': Timestamp.fromDate(new Date('2022-02-02')),
                'dateEnd': Timestamp.fromDate(new Date()),
                'actualPosition': true,
                'description': "Consultation en gestion hôtelière englobant l'ensemble du cycle de vie du produit hôtelier, y compris l'aspect nourriture et boisson.\nPlanification et développement hôtelier.\nGestion des actifs hôteliers.\nFourniture de conseils stratégiques.\nAccompagnement opérationnel en hôtellerie et pour le service de nourriture et boisson.",
                'company': 'Hôtellerie',
                'title': 'Consultant Senior'
            },
            {
                'dateStart': Timestamp.fromDate(new Date('2023-02-02')),
                'dateEnd': Timestamp.fromDate(new Date('2023-02-02')),
                'actualPosition': false,
                'description': 'Mandat avec l’objectif de réorienter la gestion de ce magnifique hôtel de 51 chambres.\nAmélioration des résultats financiers de 33% sur une période de 6 mois\nChangement de la culture des employés, révision de l’organigramme, restructure des départements\nCréation d’un plan commercial complet.',
                'company': 'Hotel 5 étoiles',
                'title': 'Directeur Général'
            },
            {
                'dateStart': Timestamp.fromDate(new Date('2021-02-02')),
                'dateEnd': Timestamp.fromDate(new Date('2021-02-02')),
                'actualPosition': false,
                'description': "Préparation en vue de la préouverture et gestion de tous les restaurants de l'hôtel, transféré de l'interne au sein du groupe hotelier pour ce projet spécial d'ouverture d’un hôtel ultra-luxueux.\nn Ouverture de 8 restaurants et bars, recrutement et formation d'une équipe de 150 employés",
                'company': 'Raffles The Palm - Dubaï, Émirats Arabes Unis',
                'title': 'Directeur de la Restauration'
            }],
        'skills': [{ 'name': 'Gestion hôtelière', 'level': 5 },
        { 'name': 'Planification stratégique', 'level': 4 },
        { 'name': 'Conseil opérationnel', 'level': 4 },
        { 'name': 'Développement commercial', 'level': 4 },
        { 'name': "Leadership d'équipe", 'level': 5 }]
    }
]

export const candidateEnglish = [
    {
        'name': 'Gerard',
        'education': [
            {
                "degree": "Bachelor of Science Major in Computer Engineering",
                "graduationDate": null,
                "institution": "University of St. La Salle - Bacolod Philippines",
                "fieldStudy": "Computer Engineering"
            }
        ],
        'experience': [
            {
                "key": "af31b1c8e8f",
                "description": "Seamless execution & timely delivery of projects from start to finish. Manage stakeholders across diverse geographies. Developed strategies, reports, processes, SOPs, and KPIs. Led & mentored a team of QA specialists. Conducted rigorous testing. Products: Web & Mobile Applications, eCommerce Technology used: JIRA, Confluence, Notion.so, GitHub, Figma, Google Workspace, DocuSign, BrowserStack, LambdaTest, Selenium, SDLC",
                "title": "IT Project Manager & QA Analyst/Lead",
                "actualPosition": false,
                "company": "CellConversion (US clients)",
                "dateEnd": Timestamp.fromDate(new Date('2024-06-06')),
                "dateStart": Timestamp.fromDate(new Date('2023-03-01'))
            },
            {
                "title": "IT Project Manager",
                "key": "f31b1c8e8f0",
                "dateEnd": Timestamp.fromDate(new Date('2023-03-01')),
                "company": "Quantum Technology Group (Guam, NMI, US clients)",
                "description": "Daily compliance with PMLC & best practices, ensuring smooth project progress. Managed stakeholders from Guam & NMI, fostering effective engagement. Enabled seamless integration of A.I. Vendors & Digital Service Providers. Products: Finance & Banking System SaaS Technology used: JIRA, M365 (Teams, SharePoint), Figma, Google Workspace, Zoho Projects",
                "actualPosition": false,
                "dateStart": Timestamp.fromDate(new Date('2022-11-01'))
            },
            {
                "dateEnd": Timestamp.fromDate(new Date('2022-09-01')),
                "actualPosition": false,
                "description": "Daily PMLC-SDLC adherence for efficient project execution & successful delivery. Led cross-functional team of Devs, Designers, BA, and QA members. Created comprehensive PMLC documentation, driving process innovation and implementation. Streamlined recruitment: job descriptions, posting, filtering, interviewing, and onboarding. Crafted QA strategies, precise testing, insightful reporting, and efficient processes. Point person for all test-related deliverables.",
                "title": "IT Project Manager, Scrum Master, QA Analyst, & Operations Assistant",
                "key": "31b1c8e8f0d",
                "dateStart": Timestamp.fromDate(new Date('2019-04-01')),
                "company": "Robot Sea Monster"
            }
        ],
        'skills': [
            {
                "level": 5,
                "key": "1b1c8e8f0d4",
                "name": "IT"
            },
            {
                "key": "b1c8e8f0d4a",
                "level": 5,
                "name": "Team Management"
            },
            {
                "level": 5,
                "key": "1c8e8f0d4ae",
                "name": "Project Management"
            },
            {
                "name": "Testing",
                "level": 5,
                "key": "c8e8f0d4ae1"
            },
            {
                "level": 3,
                "key": "8e8f0d4ae14",
                "name": "HR"
            }
        ]
    },
    {
        'name': 'tristan',
        'education': [
            {
                "institution": "University of St. La Salle - Bacolod Philippines",
                "fieldStudy": "Computer Engineering",
                "degree": "Bachelor of Science Major in Computer Engineering",
                "graduationDate": null
            }
        ],
        'experience': [
            {
                "company": "Self Image Love Full -stack Application - Capstone Project",
                "title": "Full-Stack Developer",
                "dateStart": Timestamp.fromDate(new Date("2024-01-01")),
                "actualPosition": false,
                "dateEnd": Timestamp.fromDate(new Date("2024-04-01")),
                "description": "Develop user-friendly interfaces using HTML, CSS, SASS, and JavaScript frameworks like React.\n\tEnsure responsive design and cross-browser compatibility for web applications.\n\tDesign and develop server-side logic using Node.js and Express.js.\n\tCreate and maintain databases using MongoDB and MSSQL.\n\tImplement RESTful APIs and integrate third-party services for data retrieval and processing.\n\tConnect frontend and backend components to ensure seamless data flow and functionality.\n\tImplement authentication and authorization mechanisms for user access control.\n\tMet and collaborated with clients regarding projects.\n"
            },
            {
                "description": "Establish and maintain relationships with key decision-makers in target organizations for business development. \n\tMeet potential clients, do presentations, and making business proposals. \n\tServe as a key contact for providers, particularly established contacts handling day-to-day activities; serve as a liaison between the provider and online health platform issues. \n\tMaintain a level of communication with providers, informing them of any operational and procedural changes and updates. \n\tFacilitate trainings regarding the procedures related to healthcare provider admin portal access. \n\tProvide solutions to the improvement of online health platforms.\n",
                "title": "Provider Relations Executive",
                "dateStart": Timestamp.fromDate(new Date("2018-04-01")),
                "actualPosition": false,
                "company": "NAS Administration Services",
                "dateEnd": Timestamp.fromDate(new Date("2022-09-01"))
            },
            {
                "description": "Ensured users' effective utilization of assigned materials and IT infrastructure.\n\tExecuted and supported IT manager in infrastructure-related projects and activities.\n\tManaged Windows Server 2008 R2 Active Directory, including domain controller configuration, user authentication, authorization, and group/OU creation.\n\tConfigured Cisco routers and switches.\n\tManaged Lotus Notes Domino Server, handling email account creation and deletion.\n\tParticipated in strategic planning for IT processes like data privacy, incident management, and escalation.\n\tCoordinated with global support teams to resolve IT issues efficiently.",
                "title": "IT Engineer",
                "dateStart": Timestamp.fromDate(new Date("2011-08-01")),
                "company": "Accent Micro Technologies Inc. (IBM Philippines)",
                "dateEnd": Timestamp.fromDate(new Date("2013-08-01")),
                "actualPosition": false
            },
            {
                "company": "NAS Administration Services",
                "title": "Batch Co-ordinator",
                "actualPosition": false,
                "description": "Coordinate claims submission with the payers. \n\tEvaluate re-imbursement claims in relation to the claims processing policies. \n\tCreate process flows in accordance with department’s business processes and procedures. \n\tAnswer queries related to claims submission from reimbursement team. \n\tSegregation of claims from batches and arrangement of payment orders \n\tManage the sending of payment orders and claims to the payers. \n\tValidation of submitted re-imbursement e-claims.",
                "dateStart": Timestamp.fromDate(new Date("2013-12-01")),
                "dateEnd": Timestamp.fromDate(new Date("2018-03-01"))
            },
            {
                "actualPosition": false,
                "description": "Help the company to increase its sales by 25%. \n\tLead in making designs, proposals, site survey and product demonstration for Radio communication system and CCTV Camera. \n\tManage the license acquisition from National Telecommunication Commission \n\tManage CCTV Camera installation and radio system installation. \n\tResponsible for securing on-time delivery of stocks and equipment. \n\tResponsible for inventory control and stock management.",
                "dateEnd": Timestamp.fromDate(new Date("2001-01-01")),
                "dateStart": Timestamp.fromDate(new Date("2011-07-01")),
                "company": "Vantage Point Global Trading",
                "title": "Sales Engineer"
            }
        ],
        'skills': [
            {
                "level": 4,
                "name": "IT Support"
            },
            {
                "level": 4,
                "name": "Network Administration"
            },
            {
                "name": "Business Development",
                "level": 3
            },
            {
                "level": 3,
                "name": "MERN Full Stack Application Development"
            }
        ]
    },
    {
        'name': 'RAHUL',
        'education': [
            {
                "fieldStudy": "Computer Systems Engineering",
                "graduationDate": null,
                "degree": "Bachelor of Engineering: Computer Systems Engineering (B.Eng.)",
                "institution": "Brunel University – England, UK"
            }
        ],
        'experience': [
            {
                "actualPosition": true,
                "description": "I gathered requirements for multiple business units to provide solutions and collaborated with stakeholders and technical support for cost-effective delivery. I led the analysis and documentation of business requirements, conducted journey mapping, produced project artifacts, and standardized processes for application management and support. I managed project budgets, business plans, and financial reporting, and planned and coordinated UAT and test script design. I supported CRM Dynamics 365, CityView, and DayForce HCM, implemented governance and best practices, developed user manuals and training guides, and introduced business analysis and project management templates. Additionally, I refined support models to align with organizational goals.",
                "company": "Parkland County",
                "dateStart": Timestamp.fromDate(new Date('2023-05-04')),
                "dateEnd": Timestamp.fromDate(new Date('2024-02-01')),
                "title": "Senior Business Solutions Analyst (Term Position)"
            },
            {
                "dateStart": Timestamp.fromDate(new Date('2022-09-30')),
                "actualPosition": true,
                "description": "Worked with multiple clients to analyze business needs and record user requirements to provide feasible solutions their IT problems. Gathered Requirements from various clients to perform data mapping/process mapping exercises for system integration and execution. Performed data integrations from web applications to third party/custom applications. Designed new business process workflows to align with organization goals and strategies. Utilized modern reporting and analytical tools for effective decision making and trend analysis. Integrated SAP ERP system to other custom systems within various government organizations and ensured. data integrity and compliance during the migration process ensuring clean relevant reportable data. Applied Control & governance to data/information to ensure compliance especially for audit purposes. Involved in PIR (Post Implementation Reviews) of various Projects.",
                "dateEnd": Timestamp.fromDate(new Date('2023-03-04')),
                "title": "Consultant/Business Analyst (Casual, Part-Time - Remote)",
                "company": "Ideosis Inc."
            },
            {
                "company": "Northern Alberta Institute of Technology",
                "actualPosition": false,
                "dateEnd": Timestamp.fromDate(new Date('2022-08-30')),
                "description": "Gathered, assessed, and evaluated business requirements. Executed/designed simple & complex reports using Tableau & Power BI. Maintained FMD website and applications. Gathered, assessed, and evaluated business requirements from FMD business units and translated those requirements into business and system solutions. Designed, recommended, and implemented new system, process changes and specifications for reports. Utilized a variety of Tools to execute and/or design simple/complex queries and reports to produce essential data from various FMD systems/Tools such as Tableau, Power BI, SharePoint, Service Now, PeopleSoft, Bonfire, Workday, AiM Systems and other FMD systems. Acted as the Project Lead for FMD in IT related Projects by coordinating, defining requirements, identifying project milestones & phases, monitoring and other elements of the Project. Supported Projects from conception to implementation and addressed gaps and issues that impacted timelines and quality. Worked closely with FMD business units to report issues/problems, design new systems, conduct modifications & enhancements, customizations, product upgrades and new functionality in Work Day, Service Now & PeopleSoft. Developed & executed test plans and scenarios to test new systems, modifications, enhancements, customizations, product upgrades and new functionality. Developed & delivered end user-training on FMD business processes. Developed/maintained end-user process documentation, standard operating procedures, processes and other procedures relating to the operation and use of FMD systems. Co-ordinated & evaluated IT related project requests from various FMD business units. Maintained FMD website and provided expertise for FMD systems.",
                "dateStart": Timestamp.fromDate(new Date('2022-05-30')),
                "title": "Business Analyst"
            },
            {
                "dateEnd": Timestamp.fromDate(new Date('2022-05-30')),
                "company": "Rohit Group of Companies",
                "description": "Analyzed Large groups of data to present findings using Tableau. Also, communicated any changes in the market and tracked Inventory for the purposes of keeping staff informed of the housing market and trends. Collected, analyzed & queried large amounts of data using SQL on systems/applications. Created Dashboards for management using Tableau for insights. Created Reports on Current Inventories (Homes, Materials, Fixtures etc.) for Trends/Insights. Assisted in determining market pricing for all Rohit Communities product lines in Edmonton, Calgary, and Regina. Co-ordinated multiple projects with hands on experience in project management scheduling, reporting and tracking. Utilized business process mapping for engineering/re-engineering processes aligning them with goals and strategies. Maintained and managed price lists and communicate changes to relevant parties. Updated Price Lists, Schedule B’s, and Change Orders. Compiled relevant sales information as directed from upper management. Maintained current reports on Traffic, Sales Volumes, Inventory Statuses, and other relevant sales documents. Basic knowledge of Alberta New Home Warranty policies. Self-motivation and the ability to work independently and in a team environment.",
                "actualPosition": false,
                "title": "Senior Data Consultant (Remote)",
                "dateStart": Timestamp.fromDate(new Date('2022-01-31'))
            },
            {
                "company": "CGI",
                "dateEnd": Timestamp.fromDate(new Date('2021-12-29')),
                "actualPosition": false,
                "dateStart": Timestamp.fromDate(new Date('2021-07-30')),
                "title": "Senior Business Analyst",
                "description": "Responsible for updating/migrating/maintaining D365/M365 & SharePoint Online and provided FOIP training and presented to various GoA staff (Alberta Government) in multiple ministries and organizations. Responsible for providing training to GoA Staff and Business Units. Responsible for system releases and worked with vendor to determine the best time to push to production and QA/Testing environments. Updated/maintained Microsoft 365/Dynamics 365 and SharePoint online for various GoA bodies and branches. Migrated data from one SharePoint Online instance to another. Made amendments and recommendations to the team on applicable laws and legislation as related to FOIP. Worked with government departments, authorities, agencies, boards, commissions, and other organizations in the FOIP regulation. Responsible for ensuring all extension of acts such as local public bodies, school boards, health authorities, post- secondary educational institutions, and municipalities. Evaluated consistency and importance of different business intelligence data against needs to determine optimal courses of action. Collaborated with internal business partners to implement commission arrangements. System testing and validation."
            }
        ],
        'skills': [
            {
                "level": 5,
                "name": "Communication"
            },
            {
                "level": 3,
                "name": "Project Management"
            },
            {
                "level": 5,
                "name": "Leadership"
            },
            {
                "name": "IT",
                "level": 5
            },
            {
                "name": "Relationship Building",
                "level": 5
            }
        ]
    }
]